import { t } from 'i18next';
import type { NotificationType } from '../types/handlers/notification';

export type ApiStatusPolicyOptions = {
  notify: (title: string, message?: string, type?: NotificationType) => unknown;
  /** 401 or 419. Each host reauthenticates its own way. */
  onAuthExpired?: () => void;
};

/**
 * What a host does with a failed status before the error reaches the page. Pages skip their own
 * toast for a 5xx, so the host must show one.
 */
export function applyApiStatusPolicy(status: number, options: ApiStatusPolicyOptions): void {
  if (status === 401 || status === 419) {
    options.onAuthExpired?.();
    return;
  }

  if (status === 429) {
    options.notify(t('errors:rate_limited.title'), t('errors:rate_limited.message'), 'error');
    return;
  }

  if (status >= 500) {
    options.notify(t('notifications:titles.error'), t('errors:generic'), 'error');
  }
}
